<template>
  <div class="validated-input flex flex-col">
    <div class="form bg-white"
         :style="styles.wrapper">
      <div class="form__input py-0.5 pr-0.5 pl-5 flex items-center w-full">
        <input placeholder="Type your email..."
               class="form__email-input p-0 border-none outline-none w-full h-full"
               :style="styles.input"
               @focus="isFocused = true"
               @blur="isFocused = false"
        >
        <button class="form__button border-none rounded-md min-w-8 h-8 cursor-pointer"
                :style="styles.button"
        >
          <sent-icon :styles="{buttonText: {color: styles.button.color}}"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import sentIcon from '@/assets/images/icons/chat-widget/sentIcon.vue'

export default {
  name: 'ChatPreviewInput',

  components: {
    sentIcon
  },

  props: {
    themeConfig: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isFocused: false
    }
  },

  computed: {
    styles() {
      return {
        wrapper: {
          boxShadow: `${this.themeConfig.sentMessage.bg} 0px ${this.isFocused ? 0 : 2}px ${this.isFocused ? 6 : 16}px 0`
        },
        input: {
          fontFamily: this.themeConfig.font
        },
        button: {
          background: this.themeConfig.userInput.sendButton,
          color: this.themeConfig.userInput.sendIcon
        }
      }
    }
  }
}
</script>
